import { sameSurface } from '@/utils/tokenPatterns'

const FIELD_LABELS: Record<string, string> = {
  subject: 'Fach',
  room: 'Raum',
  class_name: 'Klasse',
}

export function blockedSplitField(
  occupied: Record<string, string> | undefined,
  sourceField: string,
  part: { token: string; field: string },
  sourceToken?: string,
): string | null {
  if (!part.field || part.field === 'ignore' || part.field === 'open' || part.field === sourceField) return null
  const existing = occupied?.[part.field]
  if (!existing) return null
  if (existing !== '*' && sameSurface(existing, part.token)) return null
  const source = (sourceToken || '').trim().toLowerCase()
  if (source && existing.trim().toLowerCase() === source) return null
  return part.field
}

export function splitLands(
  occupied: Record<string, string> | undefined,
  sourceField: string,
  parts: { token: string; field: string }[],
  sourceToken?: string,
): boolean {
  return parts.every((part) => !blockedSplitField(occupied, sourceField, part, sourceToken))
}

export function occupiedFieldNote(field: string, value?: string): string {
  const label = FIELD_LABELS[field] || field
  if (!value || value === '*') return `${label} ist schon belegt`
  return `${label} ist schon belegt (${value})`
}

export function fieldFromBlockMessage(message: string): string | null {
  if (message.includes('Fach ist schon belegt')) return 'subject'
  if (message.includes('Raum ist schon belegt')) return 'room'
  if (message.includes('Klasse ist schon belegt')) return 'class_name'
  return null
}
